// Plain .mjs so the server can gate on the flag too; the registration in
// feature-flag-schedule-assignments.js imports lib/features and is client-only.
export const FEATURE_FLAG_SCHEDULE_ASSIGNMENTS_ID = "optimiser-schedule-assignments"
export const FEATURE_FLAG_SCHEDULE_ASSIGNMENTS_DEMAND = `feature-${FEATURE_FLAG_SCHEDULE_ASSIGNMENTS_ID}`
